import { useEffect } from "react";
import { useActiveOrMainShippingZone } from "../providers/shippingZones";
import { replaceCartAndInvalidateQueries } from "../providers/utils/utils";
import { useMarketMode } from "../providers/marketMode";

const useUpdateCartOnShippingZoneChangeOrMarketMode = () => {
  const { activeShippingZone } = useActiveOrMainShippingZone();
  const marketMode = useMarketMode().mode;

  useEffect(() => {
    if (activeShippingZone?.id === undefined) return;
    replaceCartAndInvalidateQueries(activeShippingZone.id);
  }, [activeShippingZone.id, marketMode]);
};

export default useUpdateCartOnShippingZoneChangeOrMarketMode;
